'use client';

import React from 'react';
import { RevshareCost } from '../types';
import { CalendarIcon } from '../../../../components/icons';

interface DateCellProps {
  cost: RevshareCost;
}

const DateCell: React.FC<DateCellProps> = ({ cost }) => {
  // Format date if time_ago is not available
  const displayDate =
    cost.time_ago ||
    (cost.created_at ? new Date(cost.created_at).toLocaleDateString('ru-RU') : '-');

  return (
    <div className="flex items-center gap-1">
      <CalendarIcon />
      <span className="text-auth-muted text-sm font-normal">{displayDate}</span>
    </div>
  );
};

export default DateCell;
